<template>
    <div class="row">
        <g-loading v-if="firstLoading" />
        <div v-else class="col-12">
            <div class="card title">
                <div class="card-body title-body">
                    <h3 class="tile-title is-line mb-2">
                        <span class='text-black'>Box chỉ số</span>
                    </h3>
                    <div class="mb-3 text-muted">(Lưu ý: Cần nhấn nút "Lưu lại" để lưu các cài đặt bạn đã thêm)</div>
                    <form-textarea :required='true' label="Mô tả" :model="formModel" attribute="desc" :errors="formErrors" />
                    <form-link label="Danh sách chỉ số" :model="formModel" :errors="formErrors" attribute="navs" />
                </div>
                <div class="card-footer text-center"> 
                    <b-button :disabled="saveLoading" variant="primary" @click="save">
                        <b-spinner v-if="saveLoading" small></b-spinner>
                        <em v-else class="fa fa-save" ></em>
                        Lưu lại
                    </b-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import crud from '@/mixins/CRUD';
    import FormLink from '@/views/page/FormRatio';

    export default {
        mixins: [crud],
        components: {FormLink},
        data: function () {
            return {
                firstLoading: true,
                service: '/etc',
                defaultFormModel: {
                    navs: [],
                },
                form: {
                    key: 'home-chiso',
                    type: 'JSON',
                    value: null,
                }
            };
        },
        methods: {
            save: function () {
                this.form.value = JSON.stringify(this.formModel);
                this.saveLoading = true;
                let method = 'post';
                let url = this.service;
                if (this.form.id) {
                    method = 'put';
                    url += `/update?id=${this.form.id}`;
                } else {
                    method = 'post';
                    url += '/create';
                }
                if (this.beforeSave) {
                    this.beforeSave();
                }
                return this.$service({url: url, method: method, data: this.form}).then(response => {
                    this.showForm = false;
                    if (this.load) {
                        this.load();
                    }
                    if (this.reloadBus) {
                        this.$bus.$emit(this.reloadBus);
                    }
                    if (response.data) {
                        this.$swal({
                            title: "Thành công",
                            text: 'Cập nhật thành công',
                            icon: 'success',
                            toast: true,
                            position: 'bottom-end',
                            timer: 5000,
                        });
                    } else {
                        this.$swal({
                            title: "Có lỗi",
                            text: 'Cập nhật thất bại',
                            icon: 'error',
                            toast: true,
                            position: 'bottom-end',
                            timer: 5000,
                        });
                    }
                    return response.data;
                }).catch(error => {
                    if (error.response.data.message) {
                        this.$swal({
                            text: error.response.data.message,
                            icon: 'error'
                        });
                        this.showForm = false;
                    } else {
                        this.$swal({
                            text: "Vui lòng kiểm tra lại thông tin",
                            icon: 'warning',
                            toast: true,
                            position: 'bottom-end',
                            timer: 3000,
                        });
                        this.formErrors = error.response.data;
                    }
                }).finally(() => {
                    this.saveLoading = false;
                });
            },
        },
        mounted: function () {
            this.$service.get(`${this.service}/get-by-key?key=${this.form.key}`).then(response => {
                if (response.data) {
                    this.form = response.data;
                    this.formModel = response.data.value ? JSON.parse(response.data.value) : Object.assign({}, this.defaultFormModel);
                } else {
                    this.formModel = Object.assign({}, this.defaultFormModel);
                }
                this.formErrors = {};
            }).finally(() => {
                this.firstLoading = false;
            });
        },
    }
</script>